module.exports = {
    //test
    // isDevelopment: false
    isDevelopment: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '' || window.location.hostname.includes('dev'),
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/enviroment.js
// module id = 158
// module chunks = 0